import React from "react";

// Chakra imports
import { Flex, useColorModeValue, Box } from "@chakra-ui/react";

// Custom components
import { MainLogo } from "components/icons/Icons";
import { HSeparator } from "components/separator/Separator";
import { useNavigate } from "react-router-dom";

export function SidebarBrand() {
  const navigate = useNavigate();
  const brandColor = useColorModeValue(
    "rgba(35, 169, 121, 0.8)",
    "rgba(35, 169, 121, 0.8)",
  );

  return (
    <Flex
      align="center"
      direction="column"
      justifyContent="flex-start"
      position={"relative"}
      pt="5px"
      pb="12px"
      onClick={() => navigate("/admin/dashboard")}
      cursor="pointer"
      role="group"
    >
      <Box px={6} py={3} w="100%" maxW="200px" mx="auto">
        <MainLogo width="100%" padding="0" />
      </Box>
      <HSeparator
        mt="10px"
        mb="12px"
        borderColor="rgba(0, 0, 0, 0.15)"
        borderWidth="1px"
        width="80%"
        borderRadius="full"
        boxShadow="0 1px 2px rgba(35, 169, 121, 0.1)"
        opacity="0.8"
        _groupHover={{
          width: "90%",
          borderColor: "rgba(0, 0, 0, 0.25)",
          boxShadow: "0 1px 4px rgba(0, 0, 0, 0.1)",
        }}
        transition="all 0.3s ease"
      />
    </Flex>
  );
}

export default SidebarBrand;
